export default class DropClient {
  constructor({ url, _get}) {
    this.url = url
    this.get = _get
  }

  help() {
    console.log('getFeaturedDrops()')
    console.log('getNfts(dropId)')
    console.log('getDropDetail(slug)')
  }

  async getFeaturedDrops() {
    const url = `${this.url}/api/v1/drops/featured`
    return await this.get(url, null, [])
  }

  async getDropDetail(slug) {
    const url = `${this.url}/api/v1/drops/${slug}`
    return await this.get(url, null, {})
  }

  async getAbiById(dropId) {
    const fallback = {contract_abi: []}
    if(!dropId) {
      return fallback
    }

    const url = `${this.url}/api/v1/drops/${dropId}/abi`
    return await this.get(url, null, fallback)
  }

}
